import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MaskLines, Reveal } from "@/components/site/Reveal";

export const AboutTeaser = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section ref={ref} data-testid="about-teaser" className="bg-[#FAFCFF] py-24 sm:py-32">
      <div className="container-x grid items-center gap-14 lg:grid-cols-12">
        <div className="relative lg:col-span-6">
          <div className="clip-frame relative aspect-[4/3] overflow-hidden rounded-3xl">
            <motion.img style={{ y, scale: 1.18 }} src="/images/team.webp" alt="Bodhatek team reviewing a client network plan" loading="lazy" className="h-full w-full object-cover" />
          </div>
          <div className="absolute -bottom-6 right-6 rounded-2xl bg-[#0E2657] px-6 py-5 text-white shadow-2xl sm:right-10">
            <p className="font-display text-3xl font-bold text-grad">1 team</p>
            <p className="text-sm text-slate-300">IT · Dispatch · Onsite</p>
          </div>
        </div>
        <div className="lg:col-span-6 lg:pl-8">
          <p className="eyebrow text-[#1777AF]">Who we are</p>
          <MaskLines lines={["Rooted in service.", "Obsessed with quality."]} className="mt-5 font-display text-4xl font-bold leading-[1.02] tracking-tight text-slate-900 sm:text-5xl" />
          <Reveal delay={0.15}>
            <p className="mt-6 max-w-lg leading-relaxed text-slate-600">
              Bodhatek was built on a simple idea: technology and the people who run it should feel like one dependable system. We pair certified engineers with a live dispatch desk so every ticket, device and site visit has an owner.
            </p>
            <Link to="/who-we-are" data-testid="about-teaser-link" className="btn-ghost mt-8 border-slate-300 text-slate-900 hover:border-[#1777AF] hover:text-[#1777AF]">
              Meet Bodhatek <ArrowUpRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
